import { render, staticRenderFns } from "./productionSvg.vue?vue&type=template&id=52104510"
import script from "./productionSvg.vue?vue&type=script&lang=js"
export * from "./productionSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports